import { render, staticRenderFns } from "./SecuredPage.vue?vue&type=template&id=15ef28c3"
import script from "./SecuredPage.vue?vue&type=script&lang=js"
export * from "./SecuredPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports